import React from 'react';
import { Box, Button, Chip, Container, Grid, Typography } from '@material-ui/core';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { HEALTH_PANELS_URL } from '../../containers/PublicWebsite/constants';

const PANELS = [
  'Heart',
  'Metabolic',
  'Hormone',
  'Inflammation & Stress',
  'Thyroid',
  'Kidney',
  'Liver',
  'Immune',
  'Nutrients',
  'Blood',
];

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      backgroundColor: theme.palette.primary.main,
      color: '#fff',
      padding: '4rem 0',
    },
    eyebrow: {
      letterSpacing: '1px',
      fontWeight: 'bold',
      fontSize: '13px',
      marginBottom: '0.5rem',
    },
    title: {
      fontWeight: 'bold',
      marginBottom: '1rem',
    },
    description: {
      opacity: 0.9,
      marginBottom: '1.5rem',
      [theme.breakpoints.up('md')]: {
        maxWidth: '90%',
      },
    },
    ctaButton: {
      backgroundColor: '#fff',
      color: theme.palette.primary.main,
      fontWeight: 'bold',
      whiteSpace: 'nowrap',
      '&:hover': {
        backgroundColor: '#f2f2f2',
      },
    },
    ctaWrapper: {
      display: 'flex',
      [theme.breakpoints.down('sm')]: {
        justifyContent: 'flex-start',
        marginTop: '1rem',
      },
      [theme.breakpoints.up('md')]: {
        justifyContent: 'flex-end',
      },
    },
    divider: {
      borderTop: '1px solid rgba(255,255,255,0.3)',
      margin: '2rem 0',
    },
    chipsWrapper: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: '0.75rem',
    },
    chip: {
      backgroundColor: 'rgba(255,255,255,0.15)',
      color: '#fff',
      fontWeight: 500,
    },
  }),
);

const HealthPanelsBanner: React.FC = () => {
  const classes = useStyles();

  return (
    <section className={classes.root}>
      <Container maxWidth="lg">
        <Grid container alignItems="center">
          <Grid item xs={12} md={8}>
            <Typography className={classes.eyebrow} component="p">
              NEW AT KENOSHA URGICARE
            </Typography>
            <Typography className={classes.title} component="h2" variant="h3">
              Know your numbers. 10 health panels, 130+ health signals, from $25.
            </Typography>
            <Typography className={classes.description} component="p" variant="h6">
              Clinician-guided biomarker testing, sampled locally and reviewed with
              you, so you know exactly what your results mean.
            </Typography>
          </Grid>
          <Grid item xs={12} md={4} className={classes.ctaWrapper}>
            <Button
              className={classes.ctaButton}
              size="large"
              variant="contained"
              endIcon={<ArrowForwardIcon />}
              href={HEALTH_PANELS_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              EXPLORE HEALTH PANELS
            </Button>
          </Grid>
        </Grid>

        <Box className={classes.divider} />

        <Box className={classes.chipsWrapper}>
          {PANELS.map(panel => (
            <Chip key={panel} className={classes.chip} label={panel} />
          ))}
        </Box>
      </Container>
    </section>
  );
};

export default HealthPanelsBanner;
